import {queryAssetsWithParameters, mapResponseToObject, queryGeoBoxWithParameters, queryGeneralProject} from "./queryAssetsWithParameters";
import {getAssetByAssetId} from "./getAssetByAssetId";
import {getSessionLockedAsset} from "./getSessionLockedAsset";

const Asset = {
    queryAssetsWithParameters: queryAssetsWithParameters,
    mapResponseToObject: mapResponseToObject,
    getAssetByAssetId: getAssetByAssetId,
    getSessionLockedAsset: getSessionLockedAsset,
    queryGeoBoxWithParameters: queryGeoBoxWithParameters,
    queryGeneralProject: queryGeneralProject,
};

export default Asset;